export const KIND_METADATA = 0
export const KIND_TEXTNOTE = 1
export const KIND_RECOMMENDSERVER = 2
export const KIND_CONTACTLIST = 3

export const CONTEXT_REQUESTED = 'r'
export const CONTEXT_PAST = 'p'
export const CONTEXT_NOW = 'n'
